import { render, staticRenderFns } from "./Importazioni.vue?vue&type=template&id=2b83fd8b"
import script from "./Importazioni.vue?vue&type=script&lang=js"
export * from "./Importazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports